/* eslint-disable prettier/prettier */
/* eslint-disable linebreak-style */

// SEO Keyword Map (Single Source of Truth)
// ใช้เพื่อให้ Title/Description/H1 สอดคล้องกันทั้งเว็บแบบ “ไม่สแปม”

export const SEO_KEYWORD_MAP = {
  home: {
    primary: 'รถมือสองเชียงใหม่',
    secondary: [
      'ฟรีดาวน์ 0%',
      'ดอกเบี้ยถูก',
      'รถบ้านมือเดียว',
      'รับประกันเครื่องเกียร์',
      'เข้าศูนย์ได้',
      'มีใบรับรอง',
    ],
    longTail: [
      'รถมือสองเชียงใหม่ คุณภาพพรีเมียม',
      'เต็นท์รถมือสองเชียงใหม่ ที่ไหนดี',
      'รถมือสองเชียงใหม่ จัดไฟแนนซ์ง่าย',
      'รถบ้านมือสองเชียงใหม่ เจ้าของขายเอง',
      'ศูนย์รวมรถยนต์มือสองเชียงใหม่',
    ],
    title: 'ศูนย์รวมรถมือสองเชียงใหม่ คัดเกรดพรีเมียม ฟรีดาวน์ | ครูหนึ่งรถสวย',
    description:
      'ศูนย์รวมรถมือสองเชียงใหม่ ครูหนึ่งรถสวย รถบ้านมือเดียวสภาพนางฟ้า ฟรีดาวน์ ดอกเบี้ยพิเศษเริ่มต้น 2.79% รับประกันเครื่องยนต์เกียร์ 1 ปีเต็ม โทร 094-064-9018',
    h1: 'ครูหนึ่งรถสวย ศูนย์รวมรถบ้านมือสองเชียงใหม่ คัดเกรดพรีเมียม',
  },

  allCars: {
    primary: 'แคตตาล็อกรถมือสองเชียงใหม่',
    secondary: [
      'ดูสต็อกรถ',
      'รถเข้าใหม่',
      'ราคาอัปเดต',
      'เลือกรถ',
      'เช็คราคา',
      'รถเก๋ง',
      'รถกระบะ',
      'SUV',
    ],
    longTail: [
      'สต็อกรถมือสองเชียงใหม่ อัปเดตวันนี้',
      'แคตตาล็อกรถบ้านเชียงใหม่ พร้อมขาย',
      'หารถเก๋งมือสองเชียงใหม่ ประหยัดน้ำมัน',
      'หารถกระบะมือสองเชียงใหม่ สภาพพร้อมใช้งาน',
      'เช็คราคารถมือสองเชียงใหม่ล่าสุด',
      'รถ SUV มือสองเชียงใหม่ รถครอบครัว',
    ],
    titleBase: 'เช็คสต็อก รถมือสองเชียงใหม่ ครบทุกรุ่น อัปเดตล่าสุด',
    descriptionBase:
      'แคตตาล็อกออนไลน์ รวมรถบ้านสมบูรณ์แบบในเชียงใหม่ อัปเดตสต็อกเรียลไทม์ เลือกรถที่ใช่ โตโยต้า ฮอนด้า อีซูซุ จองออนไลน์ได้ทันที',
    h1: 'สต็อกรถมือสองเชียงใหม่ พร้อมขายทุกคัน',
  },

  car: {
    primary: 'รถมือสองเชียงใหม่',
    secondary: ['รถบ้านแท้', 'ฟรีดาวน์', 'ผ่อนถูก', 'รับประกัน', 'ส่งฟรีทั่วไทย', 'เช็คประวัติ'],
    longTail: [
      'รถมือสองเชียงใหม่ [ยี่ห้อ]',
      'รถมือสอง [รุ่น] เชียงใหม่',
      '[ยี่ห้อ] [รุ่น] มือสองเชียงใหม่ราคา',
      '[ยี่ห้อ] มือสองเชียงใหม่ราคาดี',
      'ขาย [ยี่ห้อ] [รุ่น] เชียงใหม่',
      '[ยี่ห้อ] [รุ่น] มือสองสภาพดี',
      '[ยี่ห้อ] มือสองเชียงใหม่ฟรีดาวน์',
      'ผ่อน [ยี่ห้อ] [รุ่น] เชียงใหม่',
    ],
  },

  contact: {
    primary: 'ติดต่อ ครูหนึ่งรถสวย',
    secondary: ['รถมือสองเชียงใหม่', 'นัดหมายดูรถ', 'LINE', 'โทรศัพท์', 'สถานที่ตั้ง'],
    longTail: [
      'ติดต่อครูหนึ่งรถสวยเชียงใหม่',
      'นัดหมายดูรถเชียงใหม่',
      'เบอร์โทรศูนย์รถมือสองเชียงใหม่',
      'LINE ศูนย์รถมือสองเชียงใหม่',
      'Facebook รถมือสองเชียงใหม่',
      'สถานที่ตั้งเต็นท์รถเชียงใหม่',
      'ที่อยู่ครูหนึ่งรถสวย',
      'เบอร์โทรครูหนึ่งรถสวย',
    ],
    title: 'ติดต่อเรา | ครูหนึ่งรถสวย เต็นท์รถบ้านมือสองเชียงใหม่',
    description:
      'ติดต่อ ครูหนึ่งรถสวย รถมือสองเชียงใหม่ ตรวจสภาพครบถ้วน เช็คประวัติรถ โทร 094-064-9018, LINE, Facebook คุณภาพดี รับประกัน',
    h1: 'ติดต่อเรา',
  },

  creditCheck: {
    primary: 'บริการจัดไฟแนนซ์ รถมือสองเชียงใหม่',
    secondary: [
      'สินเชื่อรถยนต์',
      'ประเมินวงเงิน',
      'อนุมัติง่าย',
      'ผ่อนสบาย',
      'เอกสาร',
      'คำปรึกษาฟรี',
    ],
    longTail: [
      'จัดไฟแนนซ์รถเชียงใหม่',
      'สินเชื่อรถยนต์มือสองเชียงใหม่',
      'จัดไฟแนนซ์รถมือสองเชียงใหม่',
      'ผ่อนรถเชียงใหม่อนุมัติง่าย',
      'สินเชื่อรถมือสองเชียงใหม่อนุมัติง่าย',
      'ไฟแนนซ์รถเชียงใหม่',
      'ปรึกษาสินเชื่อรถเชียงใหม่',
      'ผ่อนรถเชียงใหม่ผ่อนสบาย',
      'สินเชื่อรถไม่ต้องดาวน์เชียงใหม่',
      'ผ่อนรถดอกเบี้ยพิเศษเชียงใหม่',
      'สินเชื่อรถผ่อนนานเชียงใหม่',
    ],
    title: 'รับจัดไฟแนนซ์รถมือสองเชียงใหม่ ฟรีดาวน์ อนุมัติไว | ครูหนึ่งรถสวย',
    description:
      'บริการจัดไฟแนนซ์รถมือสองเชียงใหม่ อนุมัติง่าย ผ่อนสบาย ฟรีดาวน์ 0% ให้คำปรึกษาฟรี ผ่อนนาน 84 งวด มีหลายธนาคาร โทร 094-064-9018',
    h1: 'บริการจัดไฟแนนซ์ - อนุมัติง่าย ผ่อนสบาย',
  },

  sellCar: {
    primary: 'ขายรถมือสองเชียงใหม่',
    secondary: ['ฝากขายรถ', 'ประเมินราคา', 'แลกเทิร์น', 'รับซื้อรถ', 'ราคายุติธรรม'],
    longTail: [
      'ฝากขายรถเชียงใหม่ที่ไหนดี',
      'ขายรถเชียงใหม่ราคาดี',
      'ประเมินราคารถเชียงใหม่ฟรี',
      'แลกเทิร์นรถเชียงใหม่',
      'รับซื้อรถมือสองเชียงใหม่',
      'ขายรถด่วนเชียงใหม่',
      'เทิร์นรถเชียงใหม่',
      'ประเมินราคารถฟรีเชียงใหม่',
      'ขายรถให้ศูนย์เชียงใหม่',
      'ฝากขายรถไม่เสียค่าบริการ',
      'ขายรถมือสองราคาสูง',
    ],
    title: 'รับซื้อ-ฝากขายรถมือสองเชียงใหม่ ประเมินราคาฟรี ให้ราคาสูง | ครูหนึ่งรถสวย',
    description:
      'ขายรถมือสองเชียงใหม่ ฝากขายรถ เช็คราคาขาย ราคากลางรับซื้อ ประเมินราคาฟรี รับซื้อรถทุกสภาพ โทร 094-064-9018 | ครูหนึ่งรถสวย',
    h1: 'ขายรถมือสองเชียงใหม่ • ประเมินราคา',
  },

  about: {
    primary: 'ครูหนึ่งรถสวย รถมือสองเชียงใหม่',
    secondary: ['ประสบการณ์', 'ตรวจสภาพ', 'รับประกัน', 'ศูนย์รถมือสอง', '10 ปี'],
    longTail: [
      'ครูหนึ่งรถสวยเชียงใหม่เป็นใคร',
      'ศูนย์รถมือสองเชียงใหม่ที่ไหนดี',
      'รถมือสองเชียงใหม่น่าเชื่อถือ',
      'รีวิวครูหนึ่งรถสวย',
      'ครูหนึ่งรถสวยดีไหม',
      'ประสบการณ์ครูหนึ่งรถสวย',
      'ศูนย์รถเชียงใหม่แนะนำ',
    ],
  },

  promotion: {
    primary: 'โปรโมชัน รถมือสองเชียงใหม่',
    secondary: ['ฟรีดาวน์', 'อัตราพิเศษ', 'ของแถม', 'รับประกัน', 'ลดราคา'],
    longTail: [
      'โปรโมชันรถมือสองเชียงใหม่ฟรีดาวน์',
      'โปรรถเชียงใหม่อัตราพิเศษ',
      'ข้อเสนอพิเศษรถมือสองเชียงใหม่',
      'โปรแรงรถมือสองเชียงใหม่',
      'โปรดาวน์ 0% เชียงใหม่',
      'โปรดอกเบี้ย 0% เชียงใหม่',
      'โปรส่งท้ายปีรถเชียงใหม่',
      'โปรปีใหม่รถมือสองเชียงใหม่',
    ],
  },

  paymentCalculator: {
    primary: 'คำนวณค่างวด รถมือสองเชียงใหม่',
    secondary: ['ค่างวด', 'ดาวน์', 'ดอกเบี้ย', 'ผ่อนกี่งวด', 'เครื่องคำนวณ'],
    longTail: [
      'คำนวณค่าผ่อนรถเชียงใหม่',
      'คิดค่างวดรถเชียงใหม่',
      'เครื่องคำนวณผ่อนรถมือสอง',
      'คำนวณดาวน์รถเชียงใหม่',
      'คิดดอกเบี้ยรถเชียงใหม่',
      'คำนวณผ่อนรถออนไลน์',
      'คิดค่าผ่อนรถ 60 งวด',
    ],
  },

  usedCarsLanding: {
    primary: 'ซื้อขายรถมือสองเชียงใหม่',
    secondary: [
      'ฝากขายรถเชียงใหม่',
      'รับซื้อรถมือสอง',
      'ตลาดรถมือสองเชียงใหม่',
      'รถบ้านเชียงใหม่',
      'ลำพูน',
    ],
    longTail: [
      'ซื้อขายรถมือสองเชียงใหม่ที่ไหนดี',
      'ฝากขายรถเชียงใหม่ที่ไหนดี',
      'ตลาดรถมือสองเชียงใหม่ลำพูน',
      'รับซื้อรถมือสองเชียงใหม่ราคาดี',
      'ขายรถบ้านเชียงใหม่ราคายุติธรรม',
      'รถมือสองเชียงใหม่ลำพูน',
      'แลกเทิร์นรถเชียงใหม่',
      'ฝากขายรถขายง่ายขายเร็วเชียงใหม่',
    ],
    title: 'ตลาดซื้อ-ขาย รับเทิร์น และฝากขายรถมือสองเชียงใหม่ | ครูหนึ่งรถสวย',
    description:
      'ตลาดซื้อ-ขายรถมือสองเชียงใหม่-ลำพูน ฝากขายรถง่าย ขายเร็ว ราคายุติธรรม รับซื้อและแลกเทิร์น ดูสต็อกรถคัดพิเศษ ฟรีดาวน์ 0% โทร 094-064-9018',
    h1: 'ศูนย์ซื้อ-ขายรถมือสองเชียงใหม่ ราคาถูก สภาพนางฟ้า',
  },
};

export const SEO_COPY_RULES = {
  h1: 'ต่อ 1 หน้าให้มี H1 เพียง 1 อัน และต้องสอดคล้องกับ Title',
  title: 'Title ควรมีคีย์หลัก 1 ครั้ง และมีแบรนด์ในรูปแบบที่ไม่ซ้ำซ้อน',
  description: 'Description เน้นประโยชน์ + ความน่าเชื่อถือ + CTA (โทร/ไลน์) แบบธรรมชาติ',
  headings: 'H2/H3 ใช้กระจายคีย์รอง/คำพ้อง หลีกเลี่ยงการยัดคำซ้ำ',
};

export function getSeoConfig(pageKey) {
  return SEO_KEYWORD_MAP[pageKey] || null;
}
